export const APPLICATION_STEPS = {
  PERSIST_STORAGE: 'PERSIST_STORAGE',
  AUTHENTICATION_PROCESS: 'AUTHENTICATION_PROCESS',
};
